import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PlaceIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Place`} {...props}>
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 14s5-3 5-7A5 5 0 0 0 3 7c0 4 5 7 5 7Zm0-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </Icon>
);
